// Meta Pixel (browser) — ViewContent + InitiateCheckout.
// Purchase is sent server-side via the Stripe webhook (Conversions API), not here.
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export function initMetaPixel() {
  if (typeof window === "undefined" || !PIXEL_ID || window.fbq) return;
  /* eslint-disable */
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = true; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
}

function track(eventName, params = {}) {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  window.fbq("track", eventName, params);
}

export function trackViewContent({ id, name, price, currency = "USD", contentType = "product" }) {
  track("ViewContent", {
    content_ids: id ? [String(id)] : undefined,
    content_name: name,
    content_type: contentType,
    value: Number(price) || 0,
    currency,
  });
}

export function trackInitiateCheckout({ id, value, currency = "USD", numItems = 1, name } = {}) {
  track("InitiateCheckout", {
    content_ids: id ? [String(id)] : undefined,
    content_name: name,
    content_type: "product",
    value: Number(value) || 0,
    currency,
    num_items: numItems,
  });
}
